import classNames from 'classnames';
import React from 'react';
import { Shimmer, ShimmerElementType } from '@fluentui/react';
import { makeStyles } from '@fluentui/react-components';

const rowElement = [{ type: ShimmerElementType.line, height: 32 }];
const buttonElement = [
  { type: ShimmerElementType.line, height: 32, width: '25%' },
  { type: ShimmerElementType.gap, width: '60%' },
  { type: ShimmerElementType.line, height: 16, width: '15%' },
];

const useShimmerStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
  },
});

export function LoadShimmer() {
  const styles = useShimmerStyles();
  return (
    <div className={classNames('shimmer-container', styles.container)}>
      <div>
        <Shimmer shimmerElements={[{ type: ShimmerElementType.line, height: 180 }]} style={{ marginBottom: 8 }} />
        <Shimmer shimmerElements={rowElement} style={{ marginBottom: 8 }} />
        <Shimmer shimmerElements={rowElement} style={{ marginBottom: 8 }} />
      </div>
      <Shimmer shimmerElements={buttonElement} style={{ marginBottom: 5, marginTop: 15 }} />
    </div >
  );
}
